import React, { useEffect, useState } from 'react'
import { Button, Col, Container, FormGroup, Input, Label, Row, Spinner } from 'reactstrap'
import LoginImg from '../../Assets/images/login.jpg'
import Logo from '../../Assets/images/logo.png'
import OtpInput from 'react-otp-input';
import { toast } from 'react-toastify';
import Handler from '../../Helpers/Handler';
import { useDispatch, useSelector } from 'react-redux';
import { loadingFalse, loadingTrue } from '../../Reducer/loaderSlice';
import { setCookie } from '../../Helpers/Utils';
import { useAuth } from '../../Context/AuthenticateProvider';
import { useParams } from 'react-router-dom';

const Login = () => {
  const dispatch = useDispatch();
  const { setIsAuthenticated } = useAuth();
  const loading = useSelector((state) => state?.loading?.loading);
  const { slug } = useParams()
  const [data, setData] = useState({});
  const [otpSection, setOtpSec] = useState(false);
  const [otp, setOtp] = useState("");

  const [code, setCode] = useState("");

  const handleChange = (e) => {
    setData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const sendOtp = async () => {
    if (!data?.name || data.name.length < 3) {
      toast.error("Invalid Name");
      return;
    }

    if (!data?.email || !data.email.includes("@")) {
      toast.error("Invalid Email Address");
      return;
    }

    if (!data?.mobile || data.mobile.length !== 10) {
      toast.error("Invalid Mobile Number");
      return;
    }

    dispatch(loadingTrue());

    const response = await Handler({
      method: "post",
      url: `/qr/request_otp.php`,
      data: {
        name: data?.name,
        email: data?.email,
        slug: slug,
        mobile: data?.mobile
      }
    });

    if (response?.success) {
      dispatch(loadingFalse());
      toast.success("OTP Sent Successfully");
      setTimeout(() => {
        setOtpSec(true);
      }, 800);
    } else {
      dispatch(loadingFalse());
      toast.error(response?.msg || "Something went wrong");
    }
  };

  const submitOtp = async () => {
    if (!data?.name || data.name.length < 3) {
      toast.error("Invalid Name");
      return;
    }

    if (!data?.email || !data.email.includes("@")) {
      toast.error("Invalid Email Address");
      return;
    }

    if (!data?.mobile || data.mobile.length !== 10) {
      toast.error("Invalid Mobile Number");
      return;
    }

    if (!otp || otp.length !== 4) {
      toast.error("Invalid OTP");
      return;
    }

    dispatch(loadingTrue());

    const response = await Handler({
      method: "post",
      url: `/qr/verify_otp.php`,
      data: {
        name: data?.name,
        email: data?.email,
        mobile: data?.mobile,
        slug: slug,
        otp: otp
      }
    });

    if (response?.success) {
      toast.success("Verified Successfully");
      dispatch(loadingFalse());

      setCookie('sessionToken', response?.sessionToken);

      setTimeout(() => {
        setOtpSec(true);
        setIsAuthenticated(true);
      }, 800);

    } else {
      dispatch(loadingFalse());
      toast.error(response?.msg || "OTP Verification Failed");
    }
  };

  const handleKeyUp = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      otpSection ? submitOtp() : sendOtp();
    }
  };

  useEffect(() => {
    dispatch(loadingFalse());
    const path = window.location.pathname;
    const lastPart = path.split("/").pop();
    setCode(lastPart);
    setCookie('slug', slug)
  }, []);

  return (
    <React.Fragment>
      <div className='vh-100 d-flex align-items-center login-bg'>
        <Container>
          <Row className='justify-content-center'>
            <Col xs={12} md={10} lg={10}>
              <Row className='login-wrapper align-items-center'>
                <Col xs={12} md={6} lg={6} className='p-0 d-none d-lg-flex'>
                  <div className='login-left'>
                    <img src={LoginImg} alt='login-img' />
                  </div>
                </Col>

                <Col xs={12} md={6} lg={6} className='p-0'>
                  <div className='login-right d-flex flex-column h-100'>
                    <img className='company-logo' src={Logo} alt='logo' />

                    <h3 className='mb-2 fw-bold'>Sign in</h3>
                    <h6>Welcome to Bizcarto </h6>

                    {otpSection && <h6 className='mb-4 sent-number'>OTP Sent to: {data?.email}</h6>}

                    {!otpSection ? (
                      <>
                        {/* NAME */}
                        <FormGroup className='mt-3'>
                          <Label for="name">Full Name</Label>
                          <Input
                            disabled={loading}
                            id="name"
                            name="name"
                            onKeyUp={handleKeyUp}
                            onChange={handleChange}
                            autoComplete='off'
                            value={data?.name || ""}
                            placeholder="Enter Name"
                            type="text"
                          />
                        </FormGroup>

                        {/* EMAIL */}
                        <FormGroup>
                          <Label for="email">Email Address</Label>
                          <Input
                            disabled={loading}
                            id="email"
                            name="email"
                            autoComplete='off'
                            onKeyUp={handleKeyUp}
                            onChange={handleChange}
                            value={data?.email || ""}
                            placeholder="Enter Email"
                            type="email"
                          />
                        </FormGroup>

                        {/* MOBILE */}
                        <FormGroup>
                          <Label for="mobile">Mobile Number</Label>
                          <Input
                            disabled={loading}
                            id="mobile"
                            name="mobile"
                            autoComplete='off'
                            value={data?.mobile || ""}
                            onKeyUp={handleKeyUp}
                            onChange={(e) => {
                              if (/^\d{0,10}$/.test(e.target.value)) {
                                handleChange(e);
                              }
                            }}
                            placeholder="Enter Mobile Number"
                            maxLength={10}
                            type="text"
                          />
                        </FormGroup>
                      </>
                    ) : (
                      <>
                        {/* OTP INPUT */}
                        <FormGroup>
                          <Label>Enter OTP</Label>
                          <OtpInput
                            value={otp}
                            onChange={setOtp}
                            numInputs={4}
                            renderInput={(props) => (
                              <input {...props} onKeyUp={handleKeyUp} />
                            )}
                            inputStyle={{
                              width: "80px",
                              outline: "none",
                              display: "flex",
                              margin: "0 10px"
                            }}
                          />
                        </FormGroup>

                        <div className='d-flex justify-content-between mx-3'>
                          <p>Edit Details? <span className='back' onClick={() => setOtpSec(false)}>Back</span></p>
                          <p>Resend OTP? <span className='back' onClick={() => sendOtp()}>Send Again</span></p>
                        </div>
                      </>
                    )}

                    <Button
                      disabled={loading}
                      onClick={otpSection ? submitOtp : sendOtp}
                      className='w-100 submit-btn login-btn'
                    >
                      {otpSection ? "Submit" : "Send OTP"}
                      {loading && <Spinner className='loading'> Loading...</Spinner>}
                    </Button>

                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Login;
